import React, { useEffect, useState } from "react";

const Wrapper = ({
	InIframe,
	isMobile,
	children,
	coverImage,
	backgroundColor,
}: {
	InIframe: any;
	isMobile?: boolean;
	children: any;
	coverImage?: any;
	backgroundColor?: any;
}) => {
	const [imgError, setImgError] = useState(false);
	const hasCoverImage = coverImage && !imgError;

	// Sync body background to prevent white flash on Mac overscroll
	// Apply on both desktop and mobile (but not in iframe)
	useEffect(() => {
		if (InIframe) return;
		const bodyBg = hasCoverImage
			? '#f5f5f5'
			: backgroundColor || '#F8F9F9';
		document.body.style.backgroundColor = bodyBg;
		return () => {
			document.body.style.backgroundColor = '';
		};
	}, [InIframe, hasCoverImage, backgroundColor]);

	// Actual iframe: plain white, no backgrounds
	if (InIframe) {
		return (
			<div className="bg-neutral-1 h-screen items-center flex justify-center">
				{children}
			</div>
		);
	}

	// Mobile: show community backgrounds with full-width card (no border/shadow)
	if (isMobile) {
		return (
			<section
				className="relative flex items-center justify-center min-h-screen overflow-hidden"
			>
				{hasCoverImage && (
					<img
						src={coverImage}
						alt=""
						className="absolute inset-0 w-full h-full object-cover object-center"
						style={{ opacity: 0.40 }}
						onError={() => setImgError(true)}
					/>
				)}

				{!hasCoverImage && !backgroundColor && (
					<div className="absolute inset-0 bg-background-2" />
				)}

				<div className="relative z-10 w-full bg-neutral-1">
					{children}
				</div>
			</section>
		);
	}

	// Desktop: centered card with border, shadow, and backgrounds
	return (
		<section
			className="relative flex items-center justify-center h-screen overflow-hidden"
		>
			{/* Cover image background — opacity-40 treatment (takes priority over backgroundColor) */}
			{hasCoverImage && (
				<img
					src={coverImage}
					alt=""
					className="absolute inset-0 w-full h-full object-cover object-center"
					style={{ opacity: 0.40 }}
					onError={() => setImgError(true)}
				/>
			)}

			{/* Fallback background when no cover image and no community color */}
			{!hasCoverImage && !backgroundColor && (
				<div className="absolute inset-0 bg-background-2" />
			)}

			<div
				className="relative z-10 w-full max-w-sm mx-auto border border-neutral-11 shadow-md m-4 bg-neutral-1"
				style={{ borderRadius: "8px" }}
			>
				{children}
			</div>
		</section>
	);
};

export default Wrapper;
